<template>
  <el-form
    :model="mcoupon_data"
    :rules="couponRules"
    ref="couponRef"
    label-width="180px"
    label-position="right"
    style="padding:20px 0 20px 0"
  >
    <el-form-item label="店铺logo：" style="height:100px">
      <logo
        :wh="'height:100px;width:100px;background-color:#80c4ff;font-size:20px'"
        :tag="'logo'"
        :uploadWx="true"
        @getReturn="getReturn"
        @returnClose="returnClose"
      >
        LOGO
      </logo>
      <pre style="display:inline-block;margin-left:110px;margin-top:-10px;">
        1、大小需为120像素*120像素。
        2、支持JPG/JPEG/PNG格式，且图片小于1M。
        3、可以不上传
      </pre>
    </el-form-item>
    <el-form-item label="店铺名称：" style="margin-top:40px">
      <el-input
        v-model="mcoupon_data.display_pattern_info.merchant_name"
        maxlength="12"
        show-word-limit
        placeholder=""
      ></el-input>
      <span style="display:inline-block;margin-left:20px">
        填写店铺名称
      </span>
    </el-form-item>
    <el-form-item label="批次名称：" style="margin-top:40px">
      <el-input
        v-model="mcoupon_data.stock_name"
        maxlength="21"
        show-word-limit
        placeholder="如：11月11日活动券"
      ></el-input>
      <span style="display:inline-block;margin-left:20px">
        该代金卷的批次名称
      </span>
    </el-form-item>
    <el-form-item label="适用商品范围：" style="margin-top:40px">
      <el-input
        v-model="mcoupon_data.goods_name"
        maxlength="15"
        show-word-limit
        placeholder="如：微信支付代金卷"
      ></el-input>
      <span style="display:inline-block;margin-left:20px">
        卷的适用范围（如：可口可乐可用）
      </span>
    </el-form-item>

    <el-form-item label="核销卷时间：">
      <el-col :span="5">
        <div id="date-div">
          <!-- <el-date-picker
            @change="getDate($event, 'available_end_time')"
            type="date"
            v-model="
              mcoupon_data.coupon_use_rule.coupon_available_time
                .available_begin_time
            "
            placeholder="开始日期"
          ></el-date-picker> -->
          <el-date-picker
            v-model="
              mcoupon_data.coupon_use_rule.coupon_available_time
                .available_begin_time
            "
            type="datetime"
            @change="getDate($event, 'available_begin_time')"
            placeholder="选择开始日期和时间"
          >
          </el-date-picker>
        </div>
      </el-col>
      <!-- <el-col :span="1" style="text-align:center">-</el-col> -->
      <el-col :span="5">
        <div id="date-div">
          <!-- <el-date-picker
            type="date"
            v-model="
              mcoupon_data.coupon_use_rule.coupon_available_time
                .available_end_time
            "
            @change="getDate($event, 'available_end_time')"
            placeholder="截止日期"
          ></el-date-picker> -->
          <el-date-picker
            v-model="
              mcoupon_data.coupon_use_rule.coupon_available_time
                .available_end_time
            "
            type="datetime"
            @change="getDate($event, 'available_end_time')"
            placeholder="选择截止日期和时间"
          >
          </el-date-picker>
        </div>
      </el-col>
      <!--  <el-form-item
        label="卷有效时间："
        style="min-width:1000px;margin-top:20px"
        label-width="90"
      >
        <el-input
          style="width:100px !important"
          v-model="
            mcoupon_data.coupon_use_rule.coupon_available_time
              .available_day_after_receive
          "
        ></el-input
        >&nbsp;&nbsp; 天
      </el-form-item>  --> </el-form-item
    ><el-form-item label="卷类型：">
      <el-radio-group
        v-model="mcoupon_data.stock_type"
        @change="stockTypeChange"
      >
        <el-radio :label="'NORMAL'">满减卷</el-radio>
        <el-radio :label="'DISCOUNT'">折扣卷</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item
      label="满减卷使用规则："
      v-if="mcoupon_data.stock_type == 'NORMAL'"
    >
      满&nbsp;&nbsp;<el-input
        style="width:100px !important"
        v-model="
          mcoupon_data.coupon_use_rule.fixed_normal_coupon.transaction_minimum
        "
      ></el-input
      >&nbsp;&nbsp; 元，可抵用&nbsp;&nbsp;
      <el-input
        style="width:100px !important"
        v-model="
          mcoupon_data.coupon_use_rule.fixed_normal_coupon.discount_amount
        "
      ></el-input
      >&nbsp;&nbsp;元
    </el-form-item>
    <el-form-item
      label="折扣卷使用规则："
      v-if="mcoupon_data.stock_type == 'DISCOUNT'"
    >
      满&nbsp;&nbsp;<el-input
        style="width:100px !important"
        v-model="
          mcoupon_data.coupon_use_rule.discount_coupon.transaction_minimum
        "
      ></el-input
      >&nbsp;&nbsp; 元，可享&nbsp;&nbsp;
      <el-input
        style="width:100px !important"
        v-model="mcoupon_data.coupon_use_rule.discount_coupon.discount_percent"
      ></el-input
      >&nbsp;&nbsp;折优惠
    </el-form-item>
    <el-form-item label="发卷数量：">
      <el-input
        max="1000000000"
        min="1"
        style="width:100px !important"
        v-model="mcoupon_data.stock_send_rule.max_coupons"
      ></el-input
      >&nbsp;&nbsp;张
    </el-form-item>
    <el-form-item label="用户最多可领：">
      <el-input
        max="100"
        min="1"
        style="width:100px !important"
        v-model="mcoupon_data.stock_send_rule.max_coupons_per_user"
      ></el-input
      >&nbsp;&nbsp;张</el-form-item
    >
  </el-form>
</template>
<script>
import { createWxMCoupon, upLoadWxCode } from "@/api/index";
import logo from "@/components/logo.vue";
export default {
  name: "csc",
  components: {
    logo
  },
  data() {
    return {
      mcoupon_data: {
        stock_name: "", //批次名称21
        belong_merchant: "1635710781", // 批次归属于哪个商户。
        goods_name: "", //适用商品范围15
        stock_type: "NORMAL", //批次类型NORMAL：固定面额满减券批次 DISCOUNT：折扣券批次 EXCHANGE：换购券批次
        coupon_use_rule: {
          coupon_available_time: {
            available_begin_time: "",
            available_end_time: "" //最长有效期1年
            // available_day_after_receive: 0, //卷领取后有效时间
          }, //卷核销时间
          fixed_normal_coupon: {
            discount_amount: 0, //优惠金额
            transaction_minimum: 0 //消费门槛
          },
          discount_coupon: {
            discount_percent: 0, //86折扣比例
            transaction_minimum: 0 //消费门槛
          },
          use_method: "OFF_LINE" //核销方式
          /* 枚举值：
OFF_LINE：线下滴码核销，点击券“立即使用”跳转展示券二维码详情。
MINI_PROGRAMS：线上小程序核销，点击券“立即使用”跳转至配置的商家小程序（需要添加小程序appid和path）。
PAYMENT_CODE：微信支付付款码核销，点击券“立即使用”跳转至微信支付钱包付款码。
SELF_CONSUME：用户自助核销，点击券“立即使用”跳转至用户自助操作核销界面（当前暂不支持用户自助核销）。
示例值：OFF_LINE */
        }, //核销卷相关规则

        stock_send_rule: {
          max_coupons: 10000, // 取值范围 1 ≤ value ≤ 1000000000
          max_coupons_per_user: 5, //用户可领个数，每个用户最多100张券 。
          natural_person_limit: true, //开启自然人限制
          prevent_api_abuse: true //可疑账号拦截
        },
        out_request_no: "", //商户创建批次凭据号（格式：商户id+日期+流水号）
        custom_entrance: {
          //卡详情页面，可选择多种入口引导用户。
          appid: "" //公众号appid
        },
        display_pattern_info: {
          merchant_logo_url: "", //商户logo
          merchant_name: "" //店铺名称
        },
        coupon_code_mode: "MERCHANT_UPLOAD" // 枚举值：
        /* WECHATPAY_MODE：系统分配券code。（固定22位纯数字）
MERCHANT_API：商户发放时接口指定券code。
MERCHANT_UPLOAD：商户上传自定义code，发券时系统随机选取上传的券code。
特殊规则：
1、券code模式为WECHATPAY_MODE时，是微信自动分配券code，商户不需要预存code；适用于多种场景
2、券code模式为MERCHANT_API时，无需调用上传预存code接口，调用发券接口时需指定券code；更多用在商家自有流量场景（例如：商家自有小程序、H5网页等）
3、券code模式为MERCHANT_UPLOAD，需要调用上传预存code接口上传code，调用发券接口时无需指定code；更多适用在微信支付平台流量场景（例如：支付有礼、支付有优惠等） */
      },
      couponRules: {
        activity_name: [
          { required: true, message: "请输活动名称", trigger: "blur" }
        ],
        begin_time: [
          { required: true, message: "请选择活动时间", trigger: "change" }
        ],
        activity_title: [
          { required: true, message: "请设置活动标题", trigger: "blur" }
        ],
        img_logo: [
          { required: true, message: "请设置店铺logo", trigger: "change" }
        ],
        img_activity: [
          { required: true, message: "请上传活动宣传图", trigger: "blur" }
        ]
      }
    };
  },
  computed: {},
  mounted() {},
  methods: {
    stockTypeChange(e) {},
    //上传图片返回
    getReturn(res) {
      //   console.log("返回值",res)
      switch (res.tag) {
        case "logo":
          //
          this.mcoupon_data.display_pattern_info.merchant_logo_url = res.imgsrc;
          break;
      }
    },
    //删除图片返回
    returnClose(res) {
      switch (res.tag) {
        case "logo":
          this.mcoupon_data.display_pattern_info.merchant_logo_url = "";
          break;
      }
    },

    async createCoupon() {
      /*  */
      var that = this;
      this.mcoupon_data.coupon_use_rule.fixed_normal_coupon.discount_amount = Number(
        this.mcoupon_data.coupon_use_rule.fixed_normal_coupon.discount_amount
      );
      this.mcoupon_data.coupon_use_rule.fixed_normal_coupon.transaction_minimum = Number(
        this.mcoupon_data.coupon_use_rule.fixed_normal_coupon
          .transaction_minimum
      );
      this.mcoupon_data.stock_send_rule.max_coupons = Number(
        this.mcoupon_data.stock_send_rule.max_coupons
      );
      this.mcoupon_data.stock_send_rule.max_coupons_per_user = Number(
        this.mcoupon_data.stock_send_rule.max_coupons_per_user
      );

      this.mcoupon_data.out_request_no =
        "1601011649" + this.getDateStr() + this.RandomStr(9);
      if (this.mcoupon_data.stock_type === "NORMAL") {
        delete this.mcoupon_data.coupon_use_rule.discount_coupon;
      } else if (this.mcoupon_data.stock_type === "DISCOUNT") {
        delete this.mcoupon_data.coupon_use_rule.fixed_normal_coupon;
      }
      const res = await createWxMCoupon(that.mcoupon_data);
      console.log("返回值：", res);

      if (
        res.data.return_code == "SUCCESS" &&
        res.data.result_code == "SUCCESS"
      ) {
        this.successMessage("创建商家卷成功");
        setTimeout(async () => {
          var code_list = [];
          const str = this.RandomStr(7);
          for (let a = 0; a < 200; a++) {
            let code = str + (200 + a);
            code_list.push(code);
          }
          const result = await upLoadWxCode(JSON.parse(res.data.resp_data).stock_id, {
            coupon_code_list: code_list,
            upload_request_no:
              "1601011649" + this.getDateStr() + this.RandomStr(9)
          });
          console.log("上传code：", result);
          this.$emit("createShopCoupon", "");
        }, 60000);
      } else if (res.data.return_code == "FAIL" && res.data.return_msg) {
        this.warnMessage(res.data.return_msg);
      } else if (res.data.result_code == "FAIL" && res.data.result_msg) {
        this.warnMessage(res.data.result_msg);
      }
      return;
    },
    getDate(date, str) {
      this.mcoupon_data.coupon_use_rule.coupon_available_time[
        str
      ] = this.formatDate(date, true);
    }
  }
};
</script>
<style scoped>
.el-form {
  color: #9d9fa5;
}
#date-div >>> .el-input {
  width: 200px !important;
}
.el-form-item >>> .el-input {
  width: 300px !important;
}
.el-divider--horizontal {
  height: 0.1px;
  margin-top: 5px !important;
  margin-right: 30px !important;
  margin-bottom: 0 !important;
}
.count-input {
  display: inline-block;
  width: 100px !important;
}
</style>
